import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import preloadimg from "../../assets/img/preloader1.gif";
import GoToPage from "../../assets/img/go-to-page.png";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const FiltersVisuals = (props) => {
  const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const [pbireportsConfig, setpbireportsConfig] = useState();

  const id = props.report_id;

  const pbireports = pbireportsConfig?.data;

  const [userInfo, setUserInfo] = useState(null);
  const [isloading, setIsLoading] = useState(true);
  const [Repotisloading, setRepotisloading] = useState(true);
  const [errorData, seterrorData] = useState(false);



  



  const BaseURL = `${process.env.REACT_APP_SERVER_URL}/aipd/reports/${id}`;

  useEffect(() => {
    if (isloading) {
      const fetchViusals = async () => {
        await fetch(`${BaseURL}`, {
          headers: {
            "oidc-token": passtoken,
            Accept: "application/json",
          },
        })
          .then((response) => {
            if (response.ok) {
              response.json().then((json) => {
                setpbireportsConfig(json);
                setIsLoading(false);
                seterrorData(false);

                //  console.log(isLoading);
              });
            }
          })
          .catch((err) => {
            setpbireportsConfig();
            // console.log("iserror");
            setIsLoading(false);
            seterrorData(true);
          });
      };
      fetchViusals();
    }
  }, [BaseURL, passtoken, isloading]);


  // Slicer Filtering -------------------------------------------------

  const embeddingData = pbireports?.embedReport;
  const EmbedUrl = embeddingData?.url;
  const Embedaccess_token = embeddingData?.embedToken;
  const EmbedPBIreport_id = `${embeddingData?.reportGuid}`;
  const report = window.report;
  const embdData = (TrigerdData) => {

  };



 

  return (
    <div style={{ position: "relative", height: "100%" }}>
      {Repotisloading && (
        <div
          style={{
            position: "absolute",
            background: "white",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 0,
            paddingTop: "4rem",
          }}
          className="pageLoading"
        >
          <img width={200} src={preloadimg} alt="Loading" />
        </div>
      )}

      {!isloading && !errorData && (
        <div style={{ height: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "10px",
              alignItems: "center",
            }}
          >
            <span
              style={{ fontSize: "16px", color: "#253978", fontWeight: "600" }}
            >
              {props.title}
            </span>

            <div
              style={{
                display: "flex",
                paddingBottom: "10px",
                alignItems: "center",
                gridGap: "20px",
                alignContent: "center",
              }}
            >
             

              <Link
                id="goToPage"
                style={{ color: "white", textDecoration: "none" }}
                to={`/reports/${props.report_id}/view?ReportSection=${props.report_name}`}
              >
                <img
                  src={GoToPage}
                  title="View Dahsboard"
                  alt="Dashboard"
                  width="16px"
                  style={{ background: "transparent !important" }}
                />
              </Link>
            </div>
          </div>

          <PowerBIEmbed
            embedConfig={{
              type: "visual", // Supported types: report, dashboard, tile, visual, and qna.
              id: EmbedPBIreport_id,
              embedUrl: EmbedUrl,
              accessToken: Embedaccess_token,
              tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
              pageName: `${props.report_name}`,
              visualName: `${props.visuals_id}`,
              background:"#ffffff",
              settings: {
                background: models.BackgroundType.Transparent, // or models.BackgroundType.Default
                navContentPaneEnabled: false,
                panes: {
                  filters: {
                    expanded: true,
                    visible: false,
                  },
                },
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function (event) {
                    // console.log("Report loaded");
                    setRepotisloading(false);
                  },
                ],
                [
                  "rendered",
                  function (event) {
                    // console.log("Report rendered");
                  },
                ],
                [
                  "dataSelected",
                  function (event) {
                    // console.log("Data selected event triggered");
                    // console.log(event.detail);

                    var data = event.detail;
                    var table = data.visual.table;
                    var columns = data.visual.columns;

                    // console.log("Data Selected - Table: " + table);
                    // console.log("Data Selected - Columns: " + columns);
                  },
                ],
                [
                  "saved",
                  function (event) {
                    // console.log("Report Saved");
                  },
                ],
                [
                  "error",
                  function (event) {
                    // console.log("error");
                  },
                ],
              ])
            }
            cssClassName={"report-style-class"}
            getEmbeddedComponent={embdData}
          />
        </div>
      )}

      {!isloading && errorData && (
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          There Is Some Issue On this Report, Please Contact With Admin Or Try
          Again Later
        </div>
      )}

    

      <ToastContainer />
    </div>
  );
};

export default FiltersVisuals;
